<template>
    <div class="text-center my-auto mx-4">
        <a :href="ad.destination" :title="ad.description" @click.prevent="registerClick">
            <img :src="ad.media" :alt="ad.title" :style="style" />
        </a>
        <br />
        <a :href="ad.destination" :title="ad.description" @click.prevent="registerClick">
            {{ ad.name }}
        </a>
        <br />
        <span v-if="ad.promo_code"> Promo Code: {{ ad.promo_code }} </span>
    </div>
</template>

<script>
export default {
    name: 'Advertisement',

    props: {
        ad: {
            type: Object,
            required: true,
        },
    },

    computed: {
        style() {
            const style = {};

            if (this.ad.width) {
                style.width = this.ad.width;
            }

            if (this.ad.height) {
                style.height = this.ad.height;
            }

            return style;
        },
    },

    methods: {
        registerClick() {
            const alreadyClicked = JSON.parse(localStorage.getItem('already-clicked')) || {};

            const timeClicked = alreadyClicked[this.ad.id];

            const recordClick = () => {
                axios.post('/click', { advertisement_id: this.ad.id });
                alreadyClicked[this.ad.id] = this.$moment().toDate();

                localStorage.setItem('already-clicked', JSON.stringify(alreadyClicked));
            };

            if (timeClicked) {
                if (this.$moment(timeClicked).isBefore(this.$moment().subtract(1, 'day'))) {
                    recordClick();
                }
            } else {
                recordClick();
            }

            window.open(this.ad.destination, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
.advertisement img {
    max-width: 150px;
    max-height: 150px;
}
</style>
